import { render, staticRenderFns } from "./SwifterWaitDurationSecondsForm.vue?vue&type=template&id=0488154f&scoped=true"
import script from "./SwifterWaitDurationSecondsForm.vue?vue&type=script&lang=js"
export * from "./SwifterWaitDurationSecondsForm.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0488154f",
  null
  
)

export default component.exports